import React from "react";
import Copyright from "./Copyright";
import FooterNav from "./FooterNav";
import "./footer.scss";
const Footer = () => {
  return (
    <footer className="site_footer">
      <FooterNav />
      <Copyright copyright="© Brabbles, 2020. All rights reserved." />
    </footer>
  );
};

export default Footer;
